module.exports = __webpack_public_path__ + "images/a5-portrait-95c450e12172621581da9c5acae202e2.jpg";